import {
    Box,
    Grid,
    Typography,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Skeleton
} from '@mui/material'
import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useEffect } from 'react'

export type AppFAQProps = {
    data?: Object
}

const ExternalHtmlWithScript = ({ htmlContent }) => {
    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://cdn.ckeditor.com/ckeditor5/29.0.0/classic/ckeditor.js' // 如果脚本是外部的
        script.async = true
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    )
}

export const AppFAQItem: React.FC<AppFAQProps> = (props) => {
    // ======================= PROPS
    const {
        data = null
    } = props

    const renderFaqAccordion = (index: number) => (
        <Grid item xs={12} key={'key:' + index}>
            <Accordion
                disableGutters
                sx={{
                    boxShadow: 'none',
                    backgroundColor: '#F6F6F6',
                    '&.MuiAccordion-root': {
                        borderRadius: 2,
                        mt: 0,
                    },
                    '&::before': {
                        display: 'none',
                    },
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{
                        color: '#141F39',
                    }} />}
                    sx={{
                        '&.MuiAccordionSummary-root': {
                            pl: '12px',
                            pr: '0px',
                        },
                        '.MuiAccordionSummary-expandIconWrapper': {
                            color: 'secondary.main',
                        },
                    }}
                >
                    <Typography variant='body1' fontWeight={600} pr={2}>
                        {data[index]['attributes']['question']}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        '&.MuiAccordionDetails-root': {
                            pb: 2,
                        },
                    }}
                >
                    <Box sx={{
                        paddingBottom: '20px',
                    }}>
                        <Box style={{ height: '1px', background: 'rgba(228, 228, 228, 1)' }} />
                    </Box>
                    <div className="App">
                        <ExternalHtmlWithScript htmlContent={'<div id="preview" class="ck-content">' + data[index]['attributes']['answer'] + '</div>'} />
                    </div>
                </AccordionDetails>
            </Accordion>
        </Grid>
    )

    const skeletonData = [
        '',
        '',
        ''
    ]

    const skeletonItem = (index: number) => {
        return (
            <Grid item key={index} xs={12}>
                <Box>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'40px'} style={{ borderRadius: '4px' }} ></Skeleton>
                </Box>
            </Grid>
        )
    }


    // ======================= VIEWS
    return (
        <Box sx={{paddingTop: '30px',}}>
            <Grid container spacing={'16px'}>
                {data === null || data.length === 0 ? (
                    skeletonData.map((item, index) => skeletonItem(index))
                ) : (data.map((item, index) => renderFaqAccordion(index)))}
            </Grid>
        </Box>
    )
}

// ======================= EXPORT
export default AppFAQItem